module.exports = __webpack_public_path__ + "img/the sun evolution 4-01.7fef1963.png";